import { createSlice } from '@reduxjs/toolkit'
import axios from 'axios'

const candidateSlice = createSlice({
  name: 'candidates',
  initialState: {
    allCandidates: [], // Kaikki ehdokaslistat (yleiskatsaus)
    allCandidatesLoaded: false,
    candidateDetails: {}, // Yksittäisten listojen cache: { id: { ...data, players: [] } }
    listViewStateById: {}, // Listan näkymätila: { [id]: { sort/filter/ui state } }
  },
  reducers: {
    setAllCandidates(state, action) {
      state.allCandidates = action.payload
      state.allCandidatesLoaded = true
    },
    addCandidate(state, action) {
      state.allCandidates.push(action.payload)
    },
    removeCandidate(state, action) {
      const id = action.payload
      state.allCandidates = state.allCandidates.filter(c => {
        const cId = c.id || c._id
        return cId !== id
      })
      delete state.candidateDetails[id]
      delete state.listViewStateById[id]
    },
    setCandidateDetail(state, action) {
      const { id, data } = action.payload
      state.candidateDetails[id] = data
    },
    clearCandidateDetail(state, action) {
      delete state.candidateDetails[action.payload]
    },
    clearAllCandidates(state) {
      state.allCandidates = []
      state.allCandidatesLoaded = false
      state.candidateDetails = {}
      state.listViewStateById = {}
    },
    updateCandidatePlayerCount(state, action) {
      const { id, count } = action.payload
      const candidate = state.allCandidates.find(c => (c.id || c._id) === id)
      if (candidate) {
        candidate.playersCount = count
      }
    },
    updateCandidateSummary(state, action) {
      const { id, patch } = action.payload
      const candidate = state.allCandidates.find(c => (c.id || c._id) === id)
      if (candidate && patch && typeof patch === 'object') {
        Object.assign(candidate, patch)
      }
    },
    setCandidateListViewState(state, action) {
      const { id, viewState } = action.payload || {}
      if (!id || !viewState || typeof viewState !== 'object') return

      state.listViewStateById[id] = {
        ...(state.listViewStateById[id] || {}),
        ...viewState,
      }
    },
  },
})

export const {
  setAllCandidates,
  addCandidate,
  removeCandidate,
  setCandidateDetail,
  clearCandidateDetail,
  clearAllCandidates,
  updateCandidatePlayerCount,
  updateCandidateSummary,
  setCandidateListViewState,
} = candidateSlice.actions

/**
 * Hakee kaikki ehdokaslistat. Palauttaa cachesta jos jo ladattu.
 */
export const initializeCandidates = token => {
  return async (dispatch, getState) => {
    const { candidates } = getState()
    if (candidates.allCandidatesLoaded) {
      return candidates.allCandidates
    }
    try {
      const response = await axios.get('/api/candidates', {
        headers: { 'x-oauth-token': token },
      })
      dispatch(setAllCandidates(response.data))
      return response.data
    } catch (error) {
      console.error('Error fetching candidates:', error)
      return []
    }
  }
}

/**
 * Hakee yksittäisen ehdokaslistan tiedot. Palauttaa cachesta jos löytyy.
 */
export const fetchCandidateDetail = (id, token) => {
  return async (dispatch, getState) => {
    const { candidates } = getState()
    if (candidates.candidateDetails[id]) {
      return candidates.candidateDetails[id]
    }
    try {
      const response = await axios.get(`/api/candidates/${id}`, {
        headers: { 'x-oauth-token': token },
      })
      dispatch(setCandidateDetail({ id, data: response.data }))
      return response.data
    } catch (error) {
      console.error('Error fetching candidate detail:', error)
      throw error
    }
  }
}

export default candidateSlice.reducer
